<template>
  <div class="main">
    <div class="sj-cpzx">
      产品中心 <span class="en-title">Product Center</span>
      <el-divider></el-divider>
    </div>
    <div class="product-main">
        <el-tabs type="border-card" style="height:auto; min-height: 650px;">
            <el-tab-pane label="全部">
                <div class="product-card" v-for="(item, index) in products" :key="index">
                    <el-image :src="item.imgUrl" class="image" fit="cover" :preview-src-list="item.srcList"></el-image>
                    <div class="demonstration">
                        <span style="font-weight:600; font-size:16px;">{{item.name}}</span>
                        <el-button style="font-weight:600; font-size:15px;" type="text" class="button" @click="showDetail(item)">详情</el-button>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="康复设备">
                <div class="product-card" v-for="(item, index) in prodRecures" :key="index">
                    <el-image :src="item.imgUrl" class="image" fit="cover" :preview-src-list="item.srcList"></el-image>
                    <div class="demonstration">
                        <span style="font-weight:600; font-size:16px;">{{item.name}}</span>
                        <el-button style="font-weight:600; font-size:15px;" type="text" class="button" @click="showDetail(item)">详情</el-button>
                    </div>
                </div>
            </el-tab-pane>
            <!-- <el-tab-pane label="心脑血管类">
                <div class="product-card" v-for="(item, index) in prodBrain" :key="index">
                    <el-image :src="item.imgUrl" class="image" fit="cover" :preview-src-list="item.srcList"></el-image>
                    <div class="demonstration">
                        <span>{{item.name}}</span>
                        <el-button type="text" class="button" @click="showDetail(item)">详情</el-button>
                    </div>
                </div>
            </el-tab-pane> -->
            <el-tab-pane label="高值耗材">
                <div class="product-card" v-for="(item, index) in prodCons" :key="index">
                    <el-image :src="item.imgUrl" class="image" fit="cover" :preview-src-list="item.srcList"></el-image>
                    <div class="demonstration">
                        <span style="font-weight:600; font-size:16px;">{{item.name}}</span>
                        <el-button style="font-weight:600; font-size:15px;" type="text" class="button" @click="showDetail(item)">详情</el-button>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
    <el-dialog title="产品详情" :visible.sync="cpShow" width="1250px" top="50px">
      <el-image class="cp-detail" :src="cpDetail" fit="cover"></el-image>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'products',
  data () {
    return {
      cpShow: false,
      cpDetail: '',
      products: [],
      prodRecures: [],
      prodBrain: [],
      prodCons: []
    }
  },
  mounted () {
    this.$axios.get('/static/products.json').then(res => {
      this.products = res.data
      this.products.forEach((item) => {
        if (item.type === 'kf') {
          this.prodRecures.push(item)
        } else if (item.type === 'xn') {
          this.prodBrain.push(item)
        } else if (item.type === 'hc') {
          this.prodCons.push(item)
        }
      })
    })
  },
  methods: {
    showDetail (item) {
      this.cpShow = true
      this.cpDetail = item.detail
    }
  }
}
</script>

<style scoped>
.main{
  width: 100%;
  height: auto;
  text-align: center;
  margin-top: 10px;
}
.sj-cpzx {
  width: 1800px;
  height: 60px;
  margin-top: 20px;
  text-align: left;
  display: inline-block;
  color: rgba(49, 49, 49, 0.918);
  font-size: 26px;
}
.en-title {
  font-size: 25px;
  color: rgb(149, 158, 158);
}
.product-main {
    width: 1800px;
    height: auto;
    display: inline-block;
    margin-top: 20px;
    text-align: left;
    font-size: 16px;
    margin-bottom: 50px;
}
.product-card {
    width: 543px;
    height: 338px;
    border: 3px solid #aacef8;
    border-radius: 5px;
    float: left;
    margin-left: 32px;
    margin-bottom: 20px;
}
.image {
  width: 543px;
  height: 295px;
  display: block;
  border-bottom: 2px solid #aacef8;
}
.demonstration {
    margin-top: 10px;
    margin-left: 10px;
}
.button {
  margin-right: 10px;
  padding-top: 5px;
  float: right;
}
.cp-detail {
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/products.vue